import { useAccountRpc } from '..';

export default function useUsernameAvailable() {
  const accountRpc = useAccountRpc();

  async function usernameAvailable(username: string) {
    const result = await accountRpc.usernameAvailable({ username });
    return result.data.result.data === true;
  }

  return usernameAvailable;
}
